import { render, staticRenderFns } from "./ProjetoPainelSimulacao.vue?vue&type=template&id=4aa313bc&"
import script from "./ProjetoPainelSimulacao.vue?vue&type=script&lang=js&"
export * from "./ProjetoPainelSimulacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports